import { Fragment } from 'react';

import { ChainLabel } from 'modules/chains/components/ChainLabel';

import { useSubchainLabelsStyles } from './useSubchainLabelsStyles';

interface ISubchainLabelsProps {
  labels: string[];
  Component?: React.ElementType<{
    children: React.ReactNode;
  }>;
}

export const SubchainLabels = ({
  Component = 'div',
  labels,
}: ISubchainLabelsProps) => {
  const { classes } = useSubchainLabelsStyles();

  const shouldSkipPropsForFragment = Component === Fragment;
  const componentProps = shouldSkipPropsForFragment
    ? {}
    : { className: classes.root };

  return (
    <Component {...componentProps}>
      {labels.map(label => {
        if (!label) {
          return null;
        }

        return (
          <ChainLabel
            key={label}
            labelClassName={classes.label}
            label={label}
          />
        );
      })}
    </Component>
  );
};
